import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    ListGroup,
    ListGroupItem,
    Form,
    FormGroup,
    Label,
    Input,
} from "reactstrap";
import styles from "./AddProduct.module.scss";
import { GiPanda } from "react-icons/gi";
import UploadMedia from "../../../../components/common/UploadMedia/UploadMedia";
import { FiCheck } from "react-icons/fi";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import VariationForm from "../../../../components/SellerPortalComponents/VariationForm/VariationForm";

const steps = [
    "Product Images & Videos",
    "Product Info",
    "Product details",
    "Product specs",
    "Pricing and Inventory",
    "Shipping Information",
    "Variations",
    "Compliance and Legal",
    "SEO and Keywords",
    "Additional Services",
];

const AddProduct = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [mainShowcase, setMainShowcase] = useState([]);
    const [productDetailsImages, setProductDetailsImages] = useState([]);
    const [productVideos, setProductVideos] = useState([]);
    const [value, setValue] = useState('');
    const [fileName, setFileName] = useState('');

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);  // Set the file name after selecting the file
        }
    };

    const handleStepClick = (index) => {
        setActiveStep(index);
        const targetId = steps[index].toLowerCase().replace(/ & /g, "-").replace(/\s+/g, "-");
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            const headerHeight = 80;
            const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <div className={styles.addProductContainer}>
            <h4 className={styles.sectionHeading}>Add Product</h4>

            <Container fluid className={styles.productImgVideoSection}>
                <Row className={styles.productImgVideoRow}>
                    <Col xs='12' lg={9} className={styles.productImgVideoColumn}>

                        {/* Header (Need Help) Section */}
                        <Container fluid className={styles.headingContainer}>
                            <p className={styles.welcometext}>
                                Welcome to the Maelano Seller Portal! Follow the steps to add
                                your product efficiently.
                            </p>
                            <div className={styles.helpSection}>
                                <span className={styles.helptext}>
                                    <GiPanda size={20} className={styles.helpImg} />
                                    Need help? I'm here to guide you through adding your product.
                                </span>
                            </div>
                        </Container>

                        {/* Product Images and Videos Section */}
                        <Container fluid id="product-images-videos" className={styles.productImgVideoContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Product Images and Videos</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.imgVideoWrapper}>
                                <Row className={styles.imgVideoRow}>
                                    <Col md={7} className={styles.imgVideoColumn}>

                                        <p>Main Showcase Images/Videos</p>
                                        <UploadMedia
                                            pictures={mainShowcase}
                                            setPictures={setMainShowcase}
                                            maxMedia={6}
                                            allowImages={true}
                                            allowVideos={true}
                                        />

                                        <p>Images within product details</p>
                                        <UploadMedia
                                            pictures={productDetailsImages}
                                            setPictures={setProductDetailsImages}
                                            maxMedia={3}
                                            allowImages={true}
                                            allowVideos={false}
                                        />

                                        <p>Product Videos at the bottom of Product Details</p>
                                        <UploadMedia
                                            pictures={productVideos}
                                            setPictures={setProductVideos}
                                            maxMedia={4}
                                            allowImages={false}
                                            allowVideos={true}
                                            showUrlInput={true}
                                        />

                                    </Col>
                                    <Col md={5} className={styles.imgQualityColumn}>
                                        <div className={styles.imageQuality}>
                                            <p>
                                                <GiPanda size={20} className={styles.pandaImg} />
                                                All images or videos should be of high quality
                                            </p>
                                            <p>
                                                High Quality:
                                                <FiCheck size={20} className={styles.checkImg} />
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.stepsSidebarColumn}>
                        <Container fluid className={styles.stepsSidebar}>
                            <div className={styles.stepsHeader}>Follow these steps:</div>
                            <div className={styles.stepsWrapper}>
                                <div className={styles.verticalLine}></div>
                                <ListGroup>
                                    {steps.map((step, index) => (
                                        <ListGroupItem
                                            key={index}
                                            onClick={() => handleStepClick(index)}
                                            className={`${styles.stepItem} ${activeStep === index ? styles.active : ""}`}
                                        >
                                            <span className={styles.stepIndicator}></span>
                                            {step}
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Product Information Section */}
            <Container fluid className={styles.productInfoSection}>
                <Row className={styles.productInfoRow}>
                    <Col xs='12' lg={9} className={styles.productInfoColumn}>
                        <Container id="product-info" fluid className={styles.productInfoContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Product Information</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.infoFormWrapper}>
                                <Row className={styles.infoFormRow}>
                                    <div className={styles.formSection}>
                                        <Form>
                                            <FormGroup className={styles.formGroup}>
                                                <Label for="productTitle">Product Title:</Label>
                                                <Input type="text" id="productTitle" placeholder="Enter name of the product" />
                                                <div className={styles.suggestionText}>
                                                    <GiPanda size={18} className={styles.pandaImg} />
                                                    Suggested name
                                                </div>
                                            </FormGroup>
                                            <FormGroup className={styles.formGroup}>
                                                <Label for="category">Category:</Label>
                                                <Input type="select" id="category">
                                                    <option>Choose from dropdown menu</option>
                                                    <option>Choose from dropdown menu</option>
                                                    <option>Choose from dropdown menu</option>
                                                </Input>
                                                <div className={styles.suggestionText}>
                                                    <GiPanda size={18} className={styles.pandaImg} />
                                                    Suggested category
                                                </div>
                                            </FormGroup>
                                            <FormGroup className={styles.formGroup}>
                                                <Label for="subCategory">Sub-category:</Label>
                                                <Input type="select" id="subCategory">
                                                    <option>Choose from dropdown menu</option>
                                                    <option>Choose from dropdown menu</option>
                                                    <option>Choose from dropdown menu</option>
                                                </Input>
                                                <div className={styles.suggestionText}>
                                                    <GiPanda size={18} className={styles.pandaImg} />
                                                    Suggested sub-category
                                                </div>
                                            </FormGroup>
                                            <Row className="g-0 mb-3">
                                                <Col md={6}>
                                                    <FormGroup className={styles.formGroupHalfColumn}>
                                                        <Label for="brand">Brand:</Label>
                                                        <Input type="select" id="brand">
                                                            <option>Add brand name</option>
                                                            <option>Add brand name</option>
                                                            <option>Add brand name</option>
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup className={styles.formGroupHalfColumn}>
                                                        <Label for="sku" className={styles.skuLabel}>SKU:</Label>
                                                        <Input type="text" id="sku" placeholder="Add brand name" />
                                                        <div className={styles.validationText}>
                                                            Validation:
                                                            <FiCheck size={16} className={styles.checkImg} />
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <FormGroup className={styles.formGroup}>
                                                <Label for="upc">UPC/EAN:</Label>
                                                <Input type="text" id="upc" placeholder="Enter" />
                                                <div className={styles.validationText}>
                                                    Validation:
                                                    <FiCheck size={18} className={styles.checkImg} />
                                                </div>
                                            </FormGroup>
                                        </Form>
                                    </div>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Accurate product titles help customers find your products easily.</p>
                                <p>Use brand names and descriptive keywords in your product title for better visibility.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Product Details Section */}
            <Container fluid className={styles.productDetailSection}>
                <Row className={styles.productDetailRow}>
                    <Col xs='12' lg={9} className={styles.productDetailColumn}>
                        <Container fluid className={styles.productDetailContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Product Details</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.detailFormWrapper}>
                                <Row className={styles.detailFormRow}>
                                    <Row className={styles.codeEditorRow}>
                                        <Col xs='12' lg={2} className={styles.detailsColumn}>
                                            <p>Details:</p>
                                        </Col>
                                        <Col xs='12' lg={10} className={styles.codeEditorSection}>
                                            <ReactQuill
                                                theme="snow"
                                                value={value}
                                                onChange={setValue}
                                                placeholder="Add introduction, highlights or description of your product"
                                                className={styles.codeEditor}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className={styles.aiHighlightsRow}>
                                        <Label>Make highlights using AI</Label>
                                        <Row className={styles.aiHighlightInputRow}>
                                            <Col xs='12' lg={10} className={styles.textareaInputColumn}>
                                                <Input type="textarea" placeholder="Let AI do your work..." />
                                            </Col>
                                            <Col xs='12' lg={2} className={styles.buttonsColumn}>
                                                <div className={styles.aiActionButtonsContainer}>
                                                    <Button type="button" color="primary" className={styles.generateBtn}>Generate</Button>
                                                    <Button type="button" color="secondary" className={styles.otherBtn}>Copy</Button>
                                                    <Button type="button" color="secondary" className={styles.otherBtn}>Rephrase</Button>
                                                    <Button type="button" color="secondary" className={styles.otherBtn}>Extend</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Row>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>A detailed description improves customer trust and  interest.</p>
                                <p>Highlight key features and specifications that make your product unique.</p>
                                <p>You can also generate highlights by the help of AI.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Product Specs & Custom Specification Sections */}
            <Container fluid className={styles.productSpecsSection}>
                <Row className={styles.productSpecsRow}>
                    <Col xs='12' lg={9} className={styles.productSpecsColumn}>
                        <Container fluid className={styles.productSpecsContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Product Specs</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.specsFormWrapper}>
                                <Row className={styles.specsFormRow}>
                                    <Form>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="dimensions">Dimensions:</Label>
                                            <Input type="text" id="length" placeholder="Length" className={styles.dimensionInput} />
                                            <Input type="text" id="width" placeholder="Width" className={styles.dimensionInput} />
                                            <Input type="text" id="height" placeholder="Height" className={styles.dimensionInput} />
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="weight">Weight:</Label>
                                            <Input type="text" id="weight" placeholder="Add weight" />
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="material">Material:</Label>
                                            <Input type="text" id="material" placeholder="Add material type of product" />
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="size">Size:</Label>
                                            <Button type="button" className={styles.sizeButton}>Add Size Chart</Button>
                                        </FormGroup>
                                    </Form>
                                </Row>
                            </div>
                        </Container>

                        <Container fluid className={styles.productSpecsContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Custom Specification</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.specsFormWrapper}>
                                <Row className={styles.specsFormRow}>
                                    <Form>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="specificationName" className={styles.specificationLabel}>Specification name:</Label>
                                            <Input type="text" id="specificationName" placeholder="Specification name" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Sleeve length
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="specificationType" className={styles.specificationLabel}>Specification type:</Label>
                                            <Input type="text" id="specificationType" placeholder="Specification type" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Dropdown List
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="specificationValue" className={styles.specificationLabel}>Specification value:</Label>
                                            <Input type="text" id="specificationValue" placeholder="Specification value" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Short, Long, Three-Quarter
                                            </div>
                                        </FormGroup>
                                    </Form>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Accurate dimensions, weight and type of material (of which product is made) are required for mentioning in product specs for customer ease and for calculating shipping costs.
                                </p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Pricing and Inventory Section */}
            <Container fluid className={styles.productInfoSection}>
                <Row className={styles.productInfoRow}>
                    <Col xs='12' lg={9} className={styles.productInfoColumn}>
                        <Container fluid className={styles.productInfoContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Pricing and Inventory</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.infoFormWrapper}>
                                <Row className={styles.priceInventoryFormRow}>
                                    <Form>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="price">Price:</Label>
                                            <Input type="text" id="price" placeholder="Add price" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Competitive price for this product is around $15.00
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="discountedPrice">Discounted price:</Label>
                                            <Input type="text" id="discountedPrice" placeholder="Add discount" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Competitive discounted price for this product is around $13.00
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="quantity">Quantity:</Label>
                                            <Input type="text" id="quantity" placeholder="Add stock quantity" />
                                        </FormGroup>
                                        <Row className="g-0 mb-3">
                                            <Col xs='12' lg={6}>
                                                <FormGroup className={styles.formGroupHalfColumn}>
                                                    <Label for="minQuantity">Min. order Quantity:</Label>
                                                    <Input type="text" id="minQuantity" placeholder="Add minimum order quantity" />
                                                </FormGroup>
                                            </Col>
                                            <Col xs='12' lg={6}>
                                                <FormGroup className={styles.formGroupHalfColumn}>
                                                    <Label for="maxQuantity">Max. order Quantity:</Label>
                                                    <Input type="text" id="maxQuantity" placeholder="Add maximum order quantity" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Competitive pricing can attract more buyers.</p>
                                <p>Consider your costs and the competition when setting your price.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Shipping Information Sections */}
            <Container fluid className={styles.productSpecsSection}>
                <Row className={styles.productSpecsRow}>
                    <Col xs='12' lg={9} className={styles.productSpecsColumn}>
                        <Container fluid className={styles.productSpecsContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Shipping Information</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.specsFormWrapper}>
                                <Row className={styles.shippingFormRow}>
                                    <Form>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="dimensions">Dimensions:</Label>
                                            <Input type="text" id="length" placeholder="Length" className={styles.dimensionInput} />
                                            <Input type="text" id="width" placeholder="Width" className={styles.dimensionInput} />
                                            <Input type="text" id="height" placeholder="Height" className={styles.dimensionInput} />
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="weight">Weight:</Label>
                                            <Input type="text" id="weight" placeholder="Add weight" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Based on similar products, the average weight is 1.5 kg
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="shippingOptions">Shipping Options:</Label>
                                            <Input type="select" id="shippingOptions" placeholder="Select shipping option">
                                                <option>Select shipping option</option>
                                                <option>Select shipping option</option>
                                                <option>Select shipping option</option>
                                            </Input>
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Most sellers choose Standard option for similar items
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="handlingTime">Handling time:</Label>
                                            <Input type="text" id="handlingTime" placeholder="Add handling time (days)" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Typical handling time for similar products is 1-2 business days
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="shippingCharges">Shipping Charges:</Label>
                                            <Input type="text" id="shippingCharges" placeholder="Add shipping charges" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Competitive rate for this product category is around $5.00
                                            </div>
                                        </FormGroup>
                                    </Form>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Accurate weight and dimensions help calculate correct shipping costs.</p>
                                <p>Double-check measurements to avoid shipping issues.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Variations Sections */}
            <Container fluid className={styles.productSpecsSection}>
                <Row className={styles.productSpecsRow}>
                    <Col xs='12' lg={9} className={styles.productSpecsColumn}>
                        <Container fluid className={styles.productSpecsContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Variations</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.specsFormWrapper}>
                                <Row className={styles.shippingFormRow}>
                                    <VariationForm />
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Offering variations can appeal to a wider range of customers.</p>
                                <p>Clearly label each variation (e.g., color, price) for better customer understanding.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Legal and Compliance Section */}
            <Container fluid className={styles.productSpecsSection}>
                <Row className={styles.productSpecsRow}>
                    <Col xs='12' lg={9} className={styles.productSpecsColumn}>
                        <Container fluid className={styles.productSpecsContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Legal and Compliance</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.complianceFormWrapper}>
                                <Row className={styles.complianceFormRow}>
                                    <Form>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="certifications">Certifications:</Label>
                                            <Input
                                                type="file"
                                                id="fileUpload"
                                                className="d-none"
                                                onChange={handleFileChange}
                                            />
                                            <Button
                                                color="primary"
                                                className={styles.addCertificateButton}
                                                onClick={() => document.getElementById('fileUpload').click()}
                                            >
                                                Add Certificate
                                            </Button>
                                            {fileName && (
                                                <div className={styles.fileNameDisplay}>
                                                    {fileName}
                                                </div>
                                            )}
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                Validation:
                                                <FiCheck size={18} className={styles.checkImg} />
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="complianceInformation">Compliance Information:</Label>
                                            <Input type="text" id="complianceInformation" placeholder="Add Compliance Information" />
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="warranty">Warranty:</Label>
                                            <Input type="text" id="warranty" placeholder="Add Warranty" className={styles.warrantyInput} />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                2 years warranty for similar products
                                            </div>
                                        </FormGroup>
                                    </Form>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Ensure your product meets all legal and safety standards.</p>
                                <p>Upload relevant certifications and provide detailed compliance information.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* SEO and Keywords Sections */}
            <Container fluid className={styles.productSpecsSection}>
                <Row className={styles.productSpecsRow}>
                    <Col xs='12' lg={9} className={styles.productSpecsColumn}>
                        <Container fluid className={styles.productSpecsContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>SEO and Keywords</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.seoKeywordsFormWrapper}>
                                <Row className={styles.seoKeywordsFormRow}>
                                    <Form>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="keywords">Search Keywords:</Label>
                                            <Input type="text" id="keywords" placeholder="Add keywords for searching your product" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                AI Keyword Recommendations
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="metaDescription">Meta Description:</Label>
                                            <Input type="text" id="metaDescription" placeholder="Add meta description" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                AI Suggestions
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="tags">Tags:</Label>
                                            <Input type="text" id="tags" placeholder="Add tags" />
                                            <div className={styles.suggestionText}>
                                                <GiPanda size={18} className={styles.pandaImg} />
                                                AI Auto-complete
                                            </div>
                                        </FormGroup>
                                    </Form>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Effective keywords can significantly improve search visibility.</p>
                                <p>Use keywords that customers are likely to use when searching for your product.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Additional Services Sections */}
            <Container fluid className={styles.productSpecsSection}>
                <Row className={styles.productSpecsRow}>
                    <Col xs='12' lg={9} className={styles.productSpecsColumn}>
                        <Container fluid className={styles.productSpecsContainer}>
                            <div className={styles.sectionTitle}>
                                <h5 className={styles.sectionSubHeading}>Additional Services</h5>
                                <Button type="button" className={styles.saveButton}>Save</Button>
                            </div>

                            <div className={styles.additionalFormWrapper}>
                                <Row className={styles.additionalFormRow}>
                                    <Form>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="giftWrapping" className={styles.additionalLabel}>Gift Wrapping:</Label>
                                            <div className={styles.checkMarkGroup}>
                                                {/* <Label for="giftWrapping">Check mark</Label> */}
                                                <Input type="checkbox" id="giftWrapping" />
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="personalizedMessages" className={styles.additionalLabel}>Personalized Messages:</Label>
                                            <div className={styles.checkMarkGroup}>
                                                {/* <Label for="personalizedMessages">Check mark</Label> */}
                                                <Input type="checkbox" id="personalizedMessages" />
                                            </div>
                                        </FormGroup>
                                        <FormGroup className={styles.formGroup}>
                                            <Label for="extendedWarranty" className={styles.additionalLabel}>Extended Warranty:</Label>
                                            <div className={styles.checkMarkGroup}>
                                                {/* <Label for="extendedWarranty">Check mark</Label> */}
                                                <Input type="checkbox" id="extendedWarranty" />
                                            </div>
                                        </FormGroup>
                                    </Form>
                                </Row>
                            </div>
                        </Container>
                    </Col>
                    <Col xs='12' lg={3} className={styles.guidelineColumn}>
                        <Container fluid className={styles.guidelineContainer}>
                            <div className={styles.guidelineHeader}>Tip/Guideline</div>
                            <div className={styles.guidelineText}>
                                <p>Offering gift wrapping or personalized messages can  enhance customer experience.</p>
                                <p>Clearly state the additional services available with your product.</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Add Product Button */}
            <Container fluid className={styles.productBtnContainer}>
                <Row className="g-0">
                    <Col md={9}>
                        <div className={styles.addProductBtnContainer}>
                            <Button type="button" color="primary" className={styles.productBtn}>Add Product</Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AddProduct;
